import React from "react";

import { dollarDisplay } from "EmployerApplication/CostEstimationUtils";
import { isEqual } from "lodash";
import { OnChange } from "react-final-form-listeners";

import { Body1, Body2 } from "Cobalt/BodyText";
import { CONTRIBUTION_TYPES } from "Common/Constants";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import EditEmployeeMockContributions from "./EditEmployeeMockContributions";
import EditEmployeePriceBreakdownTable from "./EditEmployeePriceBreakdownTable";

import makeBem from "Utils/makeBem";

const bem = makeBem("EditEmployeePriceBreakdown");

export const EditEmployeePriceBreakdownForm = ({
  formEmployeeProfiles,
  totals,
  medicalPlans,
  dentalPlan,
  visionPlan,
  handleEnrollingToggle,
  handleRoleChange,
  handleMedicalPlanChange,
  contributionType,
  contributionOptions,
  contributions,
  setContributionType,
  setContributions,
  handleSubmit,
  dirty,
  fullTimeEmployees,
}) => {
  const handleContributionTypeToggle = (type) => {
    if (type == CONTRIBUTION_TYPES.percentage) {
      setContributions(
        contributions.map(() => ({
          employee_contribution: 50,
          dependent_contribution: 0,
        })),
      );
    } else {
      setContributions(
        contributions.map(() => ({
          employee_contribution: 0,
          dependent_contribution: 0,
        })),
      );
    }
    setContributionType(type);
  };

  const handleEmployeeChange = (value, previous) => {
    if (dirty && !isEqual(value, previous)) {
      value.forEach((v, i) => {
        if (v.role != previous[i].role) {
          handleRoleChange(v.role, i);
        }
        if (v.selected_medical_plan != previous[i].selected_medical_plan) {
          handleMedicalPlanChange(v.selected_medical_plan, i);
        }
      });
    }
  };

  const handleContributionChange = (value, previous) => {
    if (dirty && !isEqual(value, previous)) {
      setContributions(
        value.map((v) => {
          v = {
            employee_contribution: Math.max(0, v.employee_contribution),
            dependent_contribution: Math.max(0, v.dependent_contribution),
          };

          if (contributionType == CONTRIBUTION_TYPES.percentage) {
            v = {
              employee_contribution: Math.min(100, v.employee_contribution),
              dependent_contribution: Math.min(100, v.dependent_contribution),
            };
          }
          return v;
        }),
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <SizeSwitch
        xs={
          <>
            <Row pt={4} pb={2}>
              <Col xs={12}>
                <Body2>You Pay {medicalPlans[0].carrier}</Body2>
              </Col>
            </Row>
            <Row pb={4}>
              <Col xs={12}>
                <Body2>
                  {dollarDisplay(totals.totalPremium.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
          </>
        }
        sm={
          <>
            <Row pt={4} pb={4}>
              <Col sm={6}>
                <Body1>You Pay {medicalPlans[0].carrier}</Body1>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalPremium.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
            <Row pb={3}>
              <Col sm={6}>
                <Body2>Your Employee's Share</Body2>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalEmployeeCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
            <Row pb={5}>
              <Col sm={6}>
                <Body2>Your Company's Share</Body2>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalCompanyCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
          </>
        }
      />

      <Row>
        <Col sm={Object.keys(contributionOptions).length > 1 ? 9 : 4}>
          <EditEmployeeMockContributions
            contributionType={contributionType}
            contributionOptions={contributionOptions}
            onToggle={handleContributionTypeToggle}
          />
        </Col>
      </Row>
      <EditEmployeePriceBreakdownTable
        rows={formEmployeeProfiles}
        totals={totals}
        medicalPlans={medicalPlans}
        dentalPlan={dentalPlan}
        visionPlan={visionPlan}
        handleEnrollingToggle={handleEnrollingToggle}
        contributionType={contributionType}
        contributionOptions={contributionOptions}
        contributions={contributions}
        fullTimeEmployees={fullTimeEmployees}
      />

      <OnChange name="employees">{handleEmployeeChange}</OnChange>
      <OnChange name="contributions">{handleContributionChange}</OnChange>
    </form>
  );
};

export default EditEmployeePriceBreakdownForm;
